export enum ProdutosProcerEnum {
    AERACAO_AUTOMATICA = 'aeracao_automatica',
}
